import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgxsStoragePluginModule} from '@ngxs/storage-plugin';
import {NgxsModule} from '@ngxs/store';
import {AuthState} from './shared/states/AuthState';
import {AuthUserState} from './shared/states/AuthUserState';
import {LoginBtnComponent} from './components/login-btn/login-btn.component';
import {LoginPageComponent} from './pages/login/login-page.component';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {HttpClientModule} from '@angular/common/http';
import {DashboardComponent} from './pages/dashboard/dashboard.component';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatDividerModule} from '@angular/material/divider';
import {NavigationComponent} from './navigation/navigation.component';
import {LayoutModule} from '@angular/cdk/layout';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatListModule} from '@angular/material/list';
import {MatExpansionModule} from '@angular/material/expansion';
import {UsersComponent} from './pages/amaia/users/users.component';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {HomeComponent} from './pages/home/home.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {EditUserComponent} from './pages/amaia/edit-user/edit-user.component';
import {RoleComponent} from './components/role/role.component';
import {PermissionComponent} from './components/permission/permission.component';
import {MatChipsModule} from '@angular/material/chips';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { RolesComponent } from './pages/amaia/roles/roles.component';
import {ConfigService} from './config.service';
import {configFactory} from './factories/config';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import { PermissionsComponent } from './pages/amaia/permissions/permissions.component';
import { PostsComponent } from './pages/idontcare/posts/posts.component';

@NgModule({
    declarations: [
        AppComponent, LoginBtnComponent, LoginPageComponent, DashboardComponent,
        NavigationComponent, UsersComponent, HomeComponent, EditUserComponent,
        RoleComponent, PermissionComponent, RolesComponent, ConfirmDialogComponent, PermissionsComponent, PostsComponent,
    ],
    imports: [
        NgxsModule.forRoot([AuthState, AuthUserState]), NgxsStoragePluginModule.forRoot({
            key: 'auth'
        }),
        BrowserModule, AppRoutingModule, HttpClientModule, BrowserAnimationsModule,
        MatButtonModule, MatCardModule, MatMenuModule, MatIconModule, MatSidenavModule,
        MatDividerModule, LayoutModule, MatToolbarModule, MatListModule, MatExpansionModule, FormsModule,
        MatTableModule, MatPaginatorModule, MatSortModule, MatProgressSpinnerModule, MatTooltipModule,
        MatGridListModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatChipsModule, MatAutocompleteModule,
        MatSnackBarModule, MatDialogModule
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: configFactory,
            deps: [ConfigService],
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})

export class AppModule {
}
